import {Component, inject, signal} from '@angular/core';
import {BasePageComponent} from "../pages-base/base-page.component";
import {advertisementIntegrationsPageResourceParams} from "./configs/advertisement-integrations-page-config";
import {
  RecordsTableContainerComponent
} from "../../../core/components/records-table-container/records-table-container.component";
import {ActivatedRoute} from "@angular/router";
import {TableContextService} from "../../../core/services/table-services/table-context.service";
import {FiltersValues} from "../../../core/types/records-table.types";
import { PageInfoComponent } from "../../../core/components/page-info/page-info.component";

@Component({
  selector: 'app-advertisement-integrations-page',
  imports: [
    RecordsTableContainerComponent,
    PageInfoComponent
  ],
  templateUrl: './advertisement-integrations-page.component.html',
  styleUrl: './advertisement-integrations-page.component.scss',
  providers: [ TableContextService ]
})
export class AdvertisementIntegrationsPageComponent extends BasePageComponent {
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  public readonly advertisementIntegrationsPageResourceParams = advertisementIntegrationsPageResourceParams;
  public filtersValues = signal<FiltersValues>({});

  public override ngOnInit(): void {
    super.ngOnInit();
    this.setUrlQueryParamsState();
  }

  private setUrlQueryParamsState(): void {
    this.activatedRoute.queryParamMap.subscribe(params => {
      const productId = this.parseProductId(params.get('productId'));
      productId && this.filtersValues.set({ productId: productId });
    });
  }

  private parseProductId(productIdStr: string | null): number | Array<number> | null {
    if (!productIdStr) { return null; }

    const ids = productIdStr
      .split(',')
      .map(id => Number(id.trim()))
      .filter(id => !isNaN(id));

    return ids.length === 1 ? ids[0] : ids;
  }
}
